import Cards from './Cards';
import Button from './Button';
//import CountryList from './CountryList';
import DateShare from './DateShare';
import Divider from './Divider';
import Heading from './Heading';
import HeadTitle from './HeadTitle';
//import Numbers from './Numbers';
import Subject from './Subject';
import Decoration from './Decoration';
import Calendar from './Calendar';

export function registerBlocks(config) {
  // Authors(config);
  Cards(config);
  Button(config);
  Calendar(config);
  //CountryList(config);
  DateShare(config);
  Divider(config);
  Heading(config);
  HeadTitle(config);
  //Numbers(config);
  Subject(config);
  Decoration(config);

  // Remover - usado apenas para testes
  //Errors(config);

  return config;
}
